import { render, staticRenderFns } from "./bbSydwdqjg.vue?vue&type=template&id=47beca03&scoped=true&"
import script from "./bbSydwdqjg.vue?vue&type=script&lang=js&"
export * from "./bbSydwdqjg.vue?vue&type=script&lang=js&"
import style0 from "./bbSydwdqjg.vue?vue&type=style&index=0&id=47beca03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47beca03",
  null
  
)

export default component.exports